<template>
  <v-card outlined class="rounded-lg" :loading="loading">
    <v-card-title
      class="grey darken-4 white--text pa-1 text-18 justify-center font-weight-bold"
    >
      {{ month }} de {{ year }}
    </v-card-title>
    <v-card-text
      class="px-0 pb-0 d-flex justify-center"
      :class="{ 'align-start': direction === 'row' }"
      :style="{ flexDirection: direction }"
    >
      <v-row class="mx-0" dense style="flex: 1">
        <v-col
          cols="12"
          class="grey darken-3 white--text text-center font-weight-bold"
        >
          Total
        </v-col>
        <v-col cols="6" class="px-3"> Faturamento </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.total.total_amount | currency }}
        </v-col>
        <v-col cols="6" class="px-3">
          Taxas
          <v-btn icon x-small @click="showDetailsFee = !showDetailsFee">
            <v-icon small>
              mdi-{{ showDetailsFee ? "chevron-up" : "chevron-down" }}
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right px-3">
          {{
            (groupedData.total.total_platform_fee +
              groupedData.total.total_installment_fee)
              | currency
          }}
        </v-col>
        <template v-if="showDetailsFee">
          <v-col cols="6" class="px-4 py-0 text-12"> Taxa Plataforma </v-col>
          <v-col cols="6" class="text-right px-4 py-0 text-12">
            {{ groupedData.total.total_platform_fee | currency }}
          </v-col>
          <v-col cols="6" class="px-4 py-0 text-12">
            Taxa de Parc.

            <v-tooltip top>
              <template v-slot:activator="{ props, on }">
                <v-btn x-small icon v-bind="props" v-on="on">
                  <v-icon x-small> mdi-information-outline </v-icon>
                </v-btn>
              </template>
              <span>
                Taxa de Parcelamento. Não incluida no faturamento, mas é cobrada
                pela plataforma do consolidador.
              </span>
            </v-tooltip>
          </v-col>

          <v-col cols="6" class="text-right px-4 py-0 text-12">
            {{ groupedData.total.total_installment_fee | currency }}
          </v-col>
        </template>
        <v-col cols="6" class="px-3"> Ingressos </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.total.total_tickets | number }}
        </v-col>
      </v-row>
      <v-row class="mx-0" dense style="flex: 1">
        <v-col
          cols="12"
          class="grey darken-2 white--text text-center font-weight-bold"
        >
          Online
        </v-col>
        <v-col cols="6" class="px-3"> Faturamento </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.online.total_amount | currency }}
        </v-col>
        <v-col cols="6" class="px-3">
          Taxas
          <v-btn icon x-small @click="showDetailsFee = !showDetailsFee">
            <v-icon small>
              mdi-{{ showDetailsFee ? "chevron-up" : "chevron-down" }}
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right px-3">
          {{
            (groupedData.online.total_platform_fee +
              groupedData.online.total_installment_fee)
              | currency
          }}
        </v-col>
        <template v-if="showDetailsFee">
          <v-col cols="6" class="px-4 py-0 text-12"> Taxa Plataforma </v-col>
          <v-col cols="6" class="text-right px-4 py-0 text-12">
            {{ groupedData.online.total_platform_fee | currency }}
          </v-col>
          <v-col cols="6" class="px-4 py-0 text-12">
            Taxa de Parc.
            <v-tooltip top>
              <template v-slot:activator="{ props, on }">
                <v-btn x-small icon v-bind="props" v-on="on">
                  <v-icon x-small> mdi-information-outline </v-icon>
                </v-btn>
              </template>
              <span>
                Taxa de Parcelamento. Não incluida no faturamento, mas é cobrada
                pela plataforma do consolidador.
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" class="text-right px-4 py-0 text-12">
            {{ groupedData.online.total_installment_fee | currency }}
          </v-col>
        </template>
        <v-col cols="6" class="px-3"> Ingressos </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.online.total_tickets | number }}
        </v-col>
      </v-row>

      <!-- POS -->
      <v-row class="mx-0" dense style="flex: 1">
        <v-col
          cols="12"
          class="grey darken-2 white--text text-center font-weight-bold"
        >
          POS
        </v-col>
        <v-col cols="6" class="px-3"> Faturamento </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.pos.total_amount | currency }}
        </v-col>
        <v-col cols="6" class="px-3">
          Taxas
          <v-btn icon x-small @click="showDetailsFee = !showDetailsFee">
            <v-icon small>
              mdi-{{ showDetailsFee ? "chevron-up" : "chevron-down" }}
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right px-3">
          {{
            (groupedData.pos.total_platform_fee +
              groupedData.pos.total_installment_fee)
              | currency
          }}
        </v-col>
        <template v-if="showDetailsFee">
          <v-col cols="6" class="px-4 py-0 text-12"> Taxa Plataforma </v-col>
          <v-col cols="6" class="text-right px-4 py-0 text-12">
            {{ groupedData.pos.total_platform_fee | currency }}
          </v-col>
          <v-col cols="6" class="px-4 py-0 text-12">
            Taxa de Parc.
            <v-tooltip top>
              <template v-slot:activator="{ props, on }">
                <v-btn x-small icon v-bind="props" v-on="on">
                  <v-icon x-small> mdi-information-outline </v-icon>
                </v-btn>
              </template>
              <span>
                Taxa de Parcelamento. Não incluida no faturamento, mas é cobrada
                pela plataforma do consolidador.
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="6" class="text-right px-4 py-0 text-12">
            {{ groupedData.pos.total_installment_fee | currency }}
          </v-col>
        </template>
        <v-col cols="6" class="px-3"> Ingressos </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.pos.total_tickets | number }}
        </v-col>
      </v-row>
      <!-- Courtesy -->
      <v-row class="mx-0" dense style="flex: 1">
        <v-col
          cols="12"
          class="grey darken-2 white--text text-center font-weight-bold"
        >
          Cortesia
        </v-col>
        <v-col cols="6" class="px-3"> Ingressos </v-col>
        <v-col cols="6" class="text-right px-3">
          {{ groupedData.courtesy.total_tickets | number }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    year: {
      type: Number | String,
      required: true,
    },
    month: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: "column",
    },
  },
  data() {
    return {
      showDetailsFee: false,
    };
  },
  computed: {
    groupedData() {
      const empty = {
        online: {
          total_amount: 0,
          total_platform_fee: 0,
          total_installment_fee: 0,
          total_tickets: 0,
        },
        pos: {
          total_amount: 0,
          total_platform_fee: 0,
          total_installment_fee: 0,
          total_tickets: 0,
        },
        total: {
          total_amount: 0,
          total_platform_fee: 0,
          total_installment_fee: 0,
          total_tickets: 0,
        },
        courtesy: {
          total_tickets: 0,
        },
      };
      if (!this.data || !this.data.length) return empty;
      return this.data.reduce((acc, curr) => {
        if (
          curr.paymentMethod === "COURTESY" ||
          curr.paymentType === "COURTESY"
        ) {
          acc.courtesy.total_tickets += parseInt(curr.total_tickets) || 0;
          return acc;
        }

        acc.total.total_amount += curr.total_amount || 0;
        acc.total.total_platform_fee += curr.total_platform_fee || 0;
        acc.total.total_installment_fee += curr.total_installment_fee || 0;
        acc.total.total_tickets += parseInt(curr.total_tickets) || 0;

        const key = curr.paymentMethod === "POS" ? "pos" : "online";
        acc[key].total_amount += curr.total_amount || 0;
        acc[key].total_platform_fee += curr.total_platform_fee || 0;
        acc[key].total_installment_fee += curr.total_installment_fee || 0;
        acc[key].total_tickets += parseInt(curr.total_tickets) || 0;

        return acc;
      }, empty);
    },
  },
};
</script>
